import {
    ILanguageSelectItemViewModel,
    ILanguageSelectViewModel,
} from '@monofe/ui-workspace/languageselect/interface';
import { IBaseControllerRenderResult } from '../interface';

export interface IRouteLanguageSelectArguments {
    db: string;
    sessionName: string;
}

export interface ILanguageSelectControllerProps {
    didRequestTourSelect: (languageId: number) => void;
    didRequestBack: () => void;
    route: IRouteLanguageSelectArguments;
}

export interface ILanguageSelectControllerRenderResult
    extends IBaseControllerRenderResult<{ languageId: number }> {}

export interface ILanguageSelectController {}

export interface ILanguageSelectItemControllerModel extends ILanguageSelectItemViewModel {}

export interface ILanguageSelectControllerModel extends ILanguageSelectViewModel {
    cycler: any;
    activeTitle: () => string;
    nextTitle: () => string;
    delayBetweenChangingTitle: number;
}

export enum ILanguageSelectType {
    Undef = 0,
    List = 1,
    GridFlag = 2,
    GridTile = 3,
    LastValue = 4,
}
